<template>
    <div>
        <Header></Header>
        <div class="editProfile">
            <p>ユーザ名</p>
            <input type="text" v-model="userName" class="userName">
            <p>学部学科(選択してください)</p>
            <select v-model="faculity">
                <option>情報理工学部情報理工学科</option>
                <option>経済学部経済学科国際専攻</option>
                <option>経済学部経済学科経済専攻</option>
                <option>スポーツ健康科学部スポーツ健康科学科</option>
                <option>食マネジメント学部食マネジメント学科</option>
                <option>理工学部電子情報工学科</option>
                <option>理工学部数理学科</option>
                <option>理工学部物理科学科</option>
                <option>理工学部電気電子工学科</option>
                <option>理工学部機械工学科</option>
                <option>理工学部ロボティクス学科</option>
                <option>理工学部環境都市工学科</option>
                <option>理工学部建築都市デザイン学科</option>
                <option>生命科学部応用化学科</option>
                <option>生命科学部生物工学科</option>
                <option>生命科学部生命情報学科</option>
                <option>生命科学部生命医科学科</option>
                <option>薬学部薬学科</option>
                <option>薬学部創薬科学科</option>
            </select>
            <p>学年(選択してください)</p>
            <select v-model="grade">
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
            </select>
            <br>
            <button class="btn edit" @click="edit">編集を完了する</button>
        </div>
        <!-- <Footer class="footer"></Footer> -->
    </div>
</template>

<script>
import firebase from '../plugins/firebase'
import db from '../plugins/firestore'
import Header from '../components/Header.vue'
// import Footer from '../components/Footer.vue'
// import storage from '../plugins/storage'
///////////////////////////////////////////////////////////////////////
/////////////プロフィール画像関連をもろもろコメントアウト//////////////////
///////////////////////////////////////////////////////////////////////

export default {
    components: {Header},
    data(){
        return {
            profile: {
                userName:'',
                userID:'',
                faculity:'',
                grade:'',
            }, //ユーザ名、プロ画、uid、faculity、grade、introductionが入ったオブジェクト。編集が完了されたらdispatchでvuexで管理される。
            userName: '',
            // userPhoto: '',
            userID: '',
            faculity: this.$store.getters.editProfile.faculity,
            grade: this.$store.getters.editProfile.grade,
            email:''
        }
    },
    //生成時にログインしているかどうかを確認
    created() {
        firebase.auth().onAuthStateChanged(user => {
            if(!user){
                this.$router.push({path: "/"})
            }else{
                this.email = user.email
                this.userName = user.displayName
            }
        })
    },
    methods: {
        //「編集を完了する」ボタンが押されたら、
        //user.updateでユーザ名とプロフィール画像を更新
        //db.collection.doc.setで学部学科、学年、自己紹介を更新
        //profileページに飛ばす
        edit() {
            var user = firebase.auth().currentUser;
            user.updateProfile({
                displayName: this.userName,
                // photoURL: this.userPhoto
            })
            this.userID = user.uid
            db.collection("users").doc(this.userID).set({
                // status: "ユーザ名:"+this.userName+"\n"+"学部学科:"+this.faculity+"\n"+"学年:"+this.grade+"回生"+"\n"
                faculity: this.faculity,
                grade: this.grade,
                email: this.email
                // introduction: this.introduction
            }).then(()=>{
                //ユーザ情報をもろもろprofileオブジェクトにいれて、vuexで管理する
                this.profile.userName = this.userName
                // this.profile.userPhoto = this.userPhoto
                this.profile.userID = this.userID
                this.profile.faculity = this.faculity
                this.profile.grade = this.grade
                // this.profile.introduction = this.introduction
                this.$store.dispatch('profile', this.profile)
                this.$router.push({path: "/profile"})
            })
            
        },
    }
}
</script>

<style scoped>
.edit{
    margin: 20px;
    background-color: rgba(53, 174, 243, 0.9);
}

.edit:hover{
    background-color: rgba(53, 174, 243, 1);
}

.editProfile {
    margin-top: 20px;
    text-align: center;
}

.userName {
    width: 330px;
    height: 30px;
    margin: 0 auto;
    margin-bottom: 20px;
    padding: 0px 10px;
    border-style: solid;
    border-width: 0.5px;
    border-radius: 10px;
}

select {
    width: 350px;
    height: 40px;
    margin: 0 auto;
    margin-bottom: 20px;
    padding: 0px 10px;
    border-style: solid;
    border-width: 1px;
    border-radius: 10px;
}



@media all and (max-width:670px){
    select {
        width: 300px;
    }

    .userName {
        width: 280px;
    }
}
</style>